(function (state) {
  const form = document.querySelector("#bft-form");
  const questions = form.querySelectorAll("[data-question-id]");
  const answers = form.querySelectorAll("input[type=radio]");
  const brands = form.querySelector("[name=brands]");
  const models = form.querySelectorAll("[data-brand]");

  state.partialResults = [];

  function handleErrors(response) {
    if (!response.ok) {
      return response.text().then(function (text) {
        const e = new FetchError({
          status: response.statusText,
          headers: response.headers,
          text: text,
        });
        throw e;
      });
    }
    return response;
  }

  function toggleHidden(el, show = false) {
    show ? el.removeAttribute("hidden") : el.setAttribute("hidden", "");
  }

  function setNextQuestion() {
    state.questionId += 1;

    questions.forEach((el) => {
      const questionId = parseInt(el.dataset.questionId, 10);
      toggleHidden(el, questionId === state.questionId);
    });
  }

  function getResults() {
    state.products.forEach((product) => {
      let match = true;
      const tags = product.tags.map((tag) => tag.toLowerCase());
      let counter = 0;

      if (!tags.length) {
        match = false;
      }

      state.answers.forEach((answer) => {
        if (tags.indexOf(answer) === -1) {
          match = false;
        } else {
          counter += 1;
        }
      });

      if (match) {
        state.results.push(product);
      }

      if (!match && counter > 0) {
        state.partialResults.push({
          count: counter,
          product: product,
        });
      }
    });
  }

  function getBestPartialResults() {
    const max = state.partialResults.reduce((previous, current) => {
      return previous.count > current.count ? previous : current;
    });

    return [max.product];
  }

  function setPrice(product) {
    const price = product.querySelector("[data-quantity-price]");

    if (price == null) return;

    const setProductPrice = window.hitpin
      ? window.hitpin.setProductPrice
      : null;

    if (setProductPrice != null) {
      setProductPrice(price);
    }

    price.classList.remove("hidden");
  }

  function renderResults() {
    const el = document.querySelector("#bft-results");
    const results = state.results.length
      ? state.results
      : getBestPartialResults();
    const arrayURLs = [];

    results.forEach(({ handle }) => {
      const url = `${window.theme.routes.root_url}products/${handle}?section_id=api-product-grid-item`;
      arrayURLs.push(url);
    });

    const fecthRequests = arrayURLs.map((url) =>
      fetch(url, { mode: "no-cors" }).then(handleErrors)
    );
    const productMarkups = [];

    Promise.allSettled(fecthRequests)
      .then((responses) => {
        return Promise.all(
          responses.map(async (response) => {
            if (response.status === "fulfilled") {
              productMarkups.push(await response.value.text());
            }
          })
        );
      })
      .then(() => {
        el.innerHTML = "";

        if (productMarkups.length == 2) {
          el.setAttribute("data-grid-large", "2");
        }

        if (productMarkups.length == 1) {
          el.setAttribute("data-grid-small", "1");
        }

        productMarkups.forEach((markup) => {
          const buffer = document.createElement("div");
          const product = document.createElement("div");
          buffer.innerHTML = markup;

          product.innerHTML =
            buffer.querySelector("[data-api-content]").innerHTML;

          setPrice(product);
          el.appendChild(product);
        });
      })
      .then(() => {
        el.classList.remove("loading");
      });
  }

  function setResults() {
    questions.forEach((el) => toggleHidden(el, false));
    getResults();
    renderResults();
  }

  function handleAnswer(event) {
    event.preventDefault();
    state.answers.push(event.target.value.toLowerCase());

    if (state.questionId < questions.length) {
      setNextQuestion();
    } else {
      setResults();
    }
  }

  function setModel(event) {
    event.preventDefault();

    if (event.target.value === "") {
      setNextQuestion();
    } else {
      models.forEach((el) => {
        toggleHidden(el, el.dataset.brand === event.target.value);
      });
    }
  }

  [...answers, ...models].forEach((el) =>
    el.addEventListener("change", (e) => handleAnswer(e))
  );

  brands.addEventListener("change", (e) => setModel(e));
})(window.BALL_FITTING_TOOL);
